export const hero = [
  {
    title: "Find Your Perfect accessories at PANARAIT",
    description:
      "From digital devices to books and statinory, we have something for everyone. so you can look and feel your best. Shop with us today.",
    cta: "Browse Our Collection",
  },
  {
    title: "Upgrade Your device with High-Quality accessories from PANARAIT",
    description:
      "Discover our wide range of accessories . Shop with us now and take your device  to the next level.",
    cta: "Shop Now",
  },
  {
    title: "Experience the Quality and service of PANARAIT",
    description:
      "At PANARAIT, we are committed to providing our customers with the best possible shopping experience. From the moment you visit our website, you will be greeted with a wide selection of our products. Shop with us now and see the difference for yourself.",
    cta: "Start Shopping",
  },
  {
    title: "Stay Ahead of the Trends with PANARAIT",
    description:
      "we have the latest products. Our products are made with quality materials and attention to detail, ensuring that you always look and feel your best. Shop with us now and stay ahead of the curve.",
    cta: "Shop New Arrivals",
  },
  {
    title: "Get the Best Value for Your Money at PANARAIT",
    description:
      "We believe that high-quality products doesn't have to break the bank. That's why we offer a wide range of affordable options. Shop with us and discover the best value for your money.",
    cta: "View Our Deals",
  },
  {
    title: "Join the PANARAIT Community and Get Exclusive Benefits",
    description:
      "When you shop with us, you're not just getting great products - you're joining a community of individuals who love quality. As a member of the PANARAIT community, you'll get access to exclusive discounts, early access to new products, and much more. Sign up now and start enjoying the benefits.",
    cta: "Join Now",
  },
  {
    title: "Shop the Best in Quality at PANARAIT",
    description:
      "Our products are made with the finest materials and attention to detail, ensuring that you always look and feel your best.Shop with us now and experience the difference for yourself.",
    cta: "Shop Now",
  },
  {
    title: "Find Your's Perfect at PANARAIT",
    description:
      "With a wide range of prodcts , we have something for everyone. Our products are made with Quality and durability in mind, so you can feel confident and comfortable. Shop with us now.",
    cta: "Browse Our Collection",
  },
  {
    title: "Discover the Best at PANARAIT",
    description:
      "we have the latest products. Our products are made with quality materials and attention to detail, ensuring that you always look and feel your best. Shop with us now and discover the best.",
    cta: "Shop Now",
  },
];

export const Categoris = [
  {
    id: 1,
    cat: "MOUSE&KEYBORD",
    img: "https://t3.ftcdn.net/jpg/01/82/47/28/360_F_182472844_YJTLFE1dmdK0KJWF6AdxU5A24eInzXxN.jpg",
    title: "Mouse & Key Board",
  },
  // {
  //   id: 2,
  //   cat: "STORAGEDEVICE",
  //   img: "https://cdn-aogbe.nitrocdn.com/LYdLTjFVvLmCmiqbCPnUYWCzZdgiptoK/assets/images/optimized/rev-735e2b4/www.currentware.com/wp-content/uploads/2021/01/Disable-USB-Ports-1200x480.jpg",
  //   title: "Storage Device",
  // },
  // {
  //   id: 3,
  //   cat: "PRINTER_MATERIAL",
  //   img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0qgK3Owpt32heaID0uKL3Av_hlAPsKG8oBA&s",
  //   title: "Printer Material",
  // },
  {
    id: 4,
    cat: "LAMINATOR",
    img: "https://img.freepik.com/premium-photo/photo-lamination-machines-black-background_996135-24395.jpg",
    title: "Laminator",
  },
  {
    id: 5,
    cat: "SCANNER",
    img: "https://computerbaba.co.in/wp-content/uploads/2023/04/best-canon-document-scanner-at-cheapest-price.jpg",
    title: "Scanner ",
  },
  {
    id: 6,
    cat: "ROUTER",
    img: "https://storage-asset.msi.com/global/picture/news/2023/wifi/gaming-router-20230314-1.jpg",
    title: "Router ",
  },
  {
    id: 7,
    cat: "STATIONARY",
    img: "https://c8.alamy.com/comp/TTEMK8/colourful-stationery-on-black-background-TTEMK8.jpg",
    title: "Stationery",
  },
  // {
  //   id: 8,
  //   cat: "SPEAKER",
  //   img: "https://img.freepik.com/premium-photo/image-photograph-pair-hifi-level-music-speakers-with-two-speakers-black-background_88135-33694.jpg",
  //   title: "Speaker",
  // },
  // {
  //   id: 9,
  //   cat: "CABLE",
  //   img: "https://img.freepik.com/free-photo/microphones-cables-black-background_87358-37.jpg",
  //   title: "Cable",
  // },
  // {
  //   id: 10,
  //   cat: "CCTVCAMERA",
  //   img: "https://img.freepik.com/premium-photo/surveillance-camera-videcam-cctv-camera-isolated-black-background-close-up-home-security-system-concept_154092-18151.jpg",
  //   title: "CCTV Camera",
  // },
  // {
  //   id: 11,
  //   cat: "BOOK",
  //   img: "https://img.freepik.com/free-photo/books-assortment-with-dark-background_23-2148898297.jpg?size=626&ext=jpg&ga=GA1.1.2008272138.1723593600&semt=ais_hybrid",
  //   title: "Book",
  // },
  {
    id: 12,
    cat: "OTHER",
    img: "https://assets.entrepreneur.com/content/3x2/2000/go-mobile-or-else.jpg",
    title: "Other",
  },
];
